import React, { useState } from 'react'
import { FormControl } from 'react-bootstrap'
import { enumvaluetranslations } from './enumvaluetranslations'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment'
import 'moment/locale/de'
import '../index.css'
import { parseFloatCurrency } from './formatting/floatnumberparsing';
moment.locale('de')

/**
 * Reusable hook for filtering transactions
*/
const useFilterTransactions = () => {
    /**
     * Filters passed transactions via a given searchInput, based on specific properties
     * @param {object[]} transactions array of objects containing transaction datas
     * @param {string} searchFilterInput the users given searchInput
     */
    const filterTransactionsBySearchInput = (transactions, searchFilterInput) => {
        searchFilterInput = searchFilterInput.toLowerCase()
        let transactionsCopy = [...transactions]

        if (searchFilterInput !== "") {
            transactionsCopy = transactionsCopy.filter(transaction => transaction.TransactionSysId.toLowerCase().includes(searchFilterInput)
                || transaction.CreationDate.toString().includes(searchFilterInput)
                || enumvaluetranslations(transaction.State).toLowerCase().includes(searchFilterInput)
                || transaction.Remark.toString().toLowerCase().includes(searchFilterInput)
                || transaction.SourceOrTargetName.toString().toLowerCase().includes(searchFilterInput)
                //|| transaction.SourceName.toString().toLowerCase().includes(searchFilterInput)
                //|| transaction.TargetName.toString().toLowerCase().includes(searchFilterInput)
                || transaction.Articles.some(article => {
                    for (var key in article) {
                        if (article[key].toString().toLowerCase().includes(searchFilterInput) && !key.toString().toLowerCase().includes("sysid")) {
                            return true
                        }
                    }
                }
                ))
        }
        return transactionsCopy
    }

    const filterTransactionsAndArticlesBySearchInput = (transactions, searchFilterInput) => {
        searchFilterInput = searchFilterInput.toLowerCase()
        let transactionsCopy = [...transactions]

        if (searchFilterInput !== "") {
            transactionsCopy = transactionsCopy.filter(transaction =>
                transaction.Articles.some(article => {
                    for (var key in article) {
                        if (article[key].toString().toLowerCase().includes(searchFilterInput) && !key.toString().toLowerCase().includes("sysid")) {
                            return true
                        }
                    }
                }
                ))

            transactionsCopy.forEach(transaction => {
                let articlesCopy = [...transaction.Articles]
                articlesCopy = articlesCopy.filter(article1 =>
                    article1.DesignerName.toLowerCase().includes(searchFilterInput)
                    || article1.ArticleIdFaex.toLowerCase().includes(searchFilterInput)
                )

                transaction.Articles = articlesCopy
            })
        }
        return transactionsCopy
    }

    /**
     * Filters passed transactions via a given date
     * @param {object[]} transactions array of objects containing transaction datas
     * @param {string} dateFilterInput the users chosen date to be filtered for
     */
    const filterTransactionsByDateInput = (transactions, dateFilterInput, dateField = "CreationDate") => {
        let transactionsCopy = [...transactions]

        if (dateFilterInput != "") {
            const startDate = moment(dateFilterInput.start._d).format("MM/DD/YYYY")
            const endDate = moment(dateFilterInput.end._d).format("MM/DD/YYYY")
            transactionsCopy = transactionsCopy.filter(transaction => ((moment(moment(transaction[dateField], "DD.MM.YYYY").format("MM/DD/YYYY"))).isSameOrBefore(endDate) &&
                (moment(moment(transaction[dateField], "DD.MM.YYYY").format("MM/DD/YYYY"))).isSameOrAfter(startDate)))
        }

        return transactionsCopy
    }

    /**
     * Filters passed transactions via a given selection, based on specific properties
     * @param {object[]} transactions array of objects containing transaction datas
     * @param {string} selectFilterInput the users selected filter value
     */
    const filterTransactionsBySelectInput = (transactions, selectFilterInput, selectField = "State") => {
        let transactionsCopy = [...transactions]

        if (selectFilterInput != "" && selectFilterInput != "---") {
            transactionsCopy = transactionsCopy.filter(transaction => enumvaluetranslations(transaction[selectField]) === enumvaluetranslations(selectFilterInput))
        }

        return transactionsCopy
    }

    return { filterTransactionsBySearchInput, filterTransactionsAndArticlesBySearchInput, filterTransactionsByDateInput, filterTransactionsBySelectInput }

}

const useFilterReport = () => {
    const filterReportBySearchInput = (report, searchFilterInput) => {
        searchFilterInput = searchFilterInput.toLowerCase()
        let reportCopy = [...report]

        if (searchFilterInput !== "") {
            reportCopy = reportCopy.filter(report => {
                return Object.keys(report).some(key => 
                     ((report[key] ?? "").toString().toLowerCase().includes(searchFilterInput)))
                })
        }
        return reportCopy
    }

    const filterReportByDateInput = (report, dateFilterInput, dateField = "Date") => {
        let reportCopy = [...report]

        console.log("filterReportByDateInput dateFilterInput, dateFilterInput")

        if (dateFilterInput != "") {
            const startDate = moment(dateFilterInput.start._d).format("MM/DD/YYYY")
            const endDate = moment(dateFilterInput.end._d).format("MM/DD/YYYY")
            reportCopy = reportCopy.filter(member => ((moment(moment(member[dateField], "DD.MM.YYYY").format("MM/DD/YYYY"))).isSameOrBefore(endDate) &&
                (moment(moment(member[dateField], "DD.MM.YYYY").format("MM/DD/YYYY"))).isSameOrAfter(startDate)))
        }

        return reportCopy
    }

    const filterReportBySelectInput = (report, selectFilterInput, selectField = "State") => {
        let reportCopy = [...report]

        console.log("filterReportBySelectInput", report, selectFilterInput, selectField)
        if (selectFilterInput != "" && selectFilterInput != "---") {
            reportCopy = reportCopy.filter(report => report[selectField] === selectFilterInput)
        }

        return reportCopy
    }

    return { filterReportBySearchInput, filterReportByDateInput, filterReportBySelectInput }
}

/**
 * Reusable hook for filtering articleTypes
*/
const useFilterArticleTypes = () => {
    /**
     * Filters passed transactions via a given searchInput, based on specific properties
     * @param {object[]} articleTypes array of objects containing articleType datas
     * @param {string} searchFilterInput the users given searchInput
     */
    const filterArticleTypesBySearchInput = (articleTypes, searchFilterInput) => {
        let articleTypesCopy = [...articleTypes]

        if (searchFilterInput !== "") {
            articleTypesCopy = articleTypesCopy.filter(articleType => 
                (JSON.stringify(articleType.ArticleNumberDesigner).toString()
                    + JSON.stringify(articleType.DescriptionDesigner).toString()
                    + JSON.stringify(articleType.Name).toString()
                    + JSON.stringify(parseFloatCurrency(articleType.SalePrice)).toString()
                    + JSON.stringify(articleType.Sexes).toString()
                    + JSON.stringify(articleType.ColourDescription.ColourName).toString()
                    + JSON.stringify(articleType.SizeAttribute).toString())
                .toLowerCase().includes(searchFilterInput.toLowerCase()))
        }
        return articleTypesCopy
    }

    /**
     * Filters passed transactions via a given selection, based on specific properties
     * @param {object[]} articleTypes array of objects containing articleType datas
     * @param {string} selectFilterInput the users selected filter value
     * @param {string} selectField indicates the articleTypes property after which should be filtered
     */
    const filterArticleTypesBySelectInput = (articleTypes, selectFilterInput, selectField) => {
        let articleTypesCopy = [...articleTypes]
        console.log(selectField)
        console.log(articleTypesCopy[0] !== undefined ? articleTypesCopy[0][selectField] : "")
        console.log(selectFilterInput)
        if (selectFilterInput != "" && selectFilterInput != "---") {
            articleTypesCopy = articleTypesCopy.filter(articleType => enumvaluetranslations(articleType[selectField]) === selectFilterInput)
        }

        return articleTypesCopy
    }

    return { filterArticleTypesBySearchInput, filterArticleTypesBySelectInput }
}

/**
 * StateSelect Component, used for selecting a specific value out of a list
 * @param {string[]} states array of strings with selectable values
 * @param {any} handleStateSelectChange handles the selection change
 * @param {string} stateSelect the selected value
 */
const StateSelect = (states, handleStateSelectChange, stateSelect) => {
    return (
        <FormControl className="filterForm" defaultValue={stateSelect} as="select" size="sm" onChange={handleStateSelectChange}>
            <option>---</option>
            {states.map(x => <option>{x}</option>)}
        </FormControl>
    )
}

/**
 * DateSelect Component for selecting a date or daterange, uses internal DateRangePicker
 * @param {any} handleDatePickerCallback handles the selection of a date
 * @param {any} handleClearFilter handles resetting the date selection
 */
const DateSelect = (handleDatePickerCallback, handleClearFilter, dateSelect) => {
    const showCustomRangeLabel = false

    const getDefaultValue = () => {
        if (dateSelect !== "" && dateSelect.start._d !== "") {
            const startDate = moment(dateSelect.start._d).format("DD.MM.YYYY")
            const endDate = moment(dateSelect.end._d).format("DD.MM.YYYY")
            return (startDate +
                ' - ' + endDate)
        }
    }
    const handleApply = (event, picker) => {
        picker.element.val(
            picker.startDate.format('DD.MM.YYYY') +
            ' - ' +
            picker.endDate.format('DD.MM.YYYY')
        )
        handleDatePickerCallback(picker.startDate, picker.endDate)
    }
    const handleCancel = (event, picker) => {
        picker.element.val('')
        handleClearFilter()
    }
    const handleCallback = (start, end) => {
        //24.01.22 RB: onCallback from DateRangePicker seems to be broken, 
        //handles setting the datepicker variables via handleApply now(called when pressing OK button)

        //handleDatePickerCallback(start, end)
    }

    return (
        <DateRangePicker initialSettings={{
            showCustomRangeLabel,
            locale: {
                cancelLabel: 'Zurücksetzen',
                applyLabel: 'Ok'
            },
            autoUpdateInput: false,
        }} onApply={handleApply} onCancel={handleCancel}
            onCallback={(start, end) => handleCallback(start, end)} isClearable={true}>
            <FormControl className="dateFilterForm" size="sm" defaultValue={getDefaultValue()} />
        </DateRangePicker>
    );
}

/**
 * Hook for filtering a date, returns the selection as well as callbacks for selecting and clearing an input
*/
const useDateFilter = () => {
    const [dateSelect, setDateSelect] = useState("")

    const handleDatePickerCallback = (start, end) => {
        const dateFilter = { start, end }
        setDateSelect(dateFilter)
    }
    const handleClearFilter = () => {
        setDateSelect("")
    }

    return { dateSelect, handleDatePickerCallback, handleClearFilter }
}

/**
 * Hook for filtering via text input, returns the input as well as an input change handler
*/
const useSearchFilter = () => {
    const [searchInput, setSearchInput] = useState("")

    const handleSearchInput = (e) => {
        const searchFilterInput = (e.target.value).toLowerCase()
        setSearchInput(searchFilterInput)
    }

    return { searchInput, handleSearchInput }
}

/**
 * Hook for filtering via select, returns the selection as well as an selection change handler
*/
const useSelectFilter = () => {
    const [statusSelect, setStatusSelect] = useState("---")

    const handleStatusSelectChange = (e) => {
        e.preventDefault()
        const status = e.target.value
        setStatusSelect(status)
    }

    return [ statusSelect, handleStatusSelectChange ]
}

export {
    useFilterTransactions, useFilterArticleTypes,
    useFilterReport,
    useDateFilter, useSearchFilter, useSelectFilter,
    StateSelect, DateSelect
}